/* eslint-disable @typescript-eslint/no-explicit-any */
import { ForecastChartDataKeys } from "../services/financial-forecast-chart";

export const lineStyles: Record<ForecastChartDataKeys, any> = {
  pastData: {
    backgroundColor: "#0284C7",
    borderColor: "#0284C7",
    pointBorderColor: "#0284C7",
    pointHoverBorderColor: "#FFF",
    borderWidth: 4,
    pointRadius: 5,
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 2,
  },
  maxForecast: {
    backgroundColor: "#16A34A1A",
    pointBorderColor: "#16A34A",
    pointHoverBorderColor: "#FFF",
    borderWidth: 0,
    pointBorderWidth: 1,
    pointRadius: 5,
    pointHoverRadius: 5,
    fill: 3,
  },
  avgForecast: {
    backgroundColor: "#16A34A",
    borderColor: "#16A34A",
    pointBorderColor: "#16A34A",
    pointHoverBorderColor: "#FFF",
    borderWidth: 4,
    pointRadius: 5,
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 2,
  },
  minForecast: {
    backgroundColor: "#16A34A1A",
    pointBorderColor: "#16A34A",
    pointHoverBorderColor: "#FFF",
    borderWidth: 0,
    pointBorderWidth: 1,
    pointRadius: 5,
    pointHoverRadius: 5,
  },
};
